import { ref as w, computed as s, onMounted as C, createBlock as d, openBlock as o, Transition as h, withCtx as N, createElementBlock as m, createCommentVNode as c, normalizeClass as p, createElementVNode as f, unref as l, createVNode as T } from "vue";
import { useTracking as j } from "../../composables/useTracking.js";
/* empty css                      */
import B from "../../_virtual/_plugin-vue_export-helper.js";
import z from "../../atoms/icon/icon.vue.js";
import M from "../link/link.vue.js";
import O from "../../atoms/icon-core/icon-core.vue.js";
const $ = { class: "notification-bar__text-container ds-display-flex ds-align-items-center ds-justify-content-center" }, E = {
  tabindex: "0",
  class: "notification-bar__text ds-display-flex ds-align-items-center"
}, k = "DsNotificationBar", I = /* @__PURE__ */ Object.assign({
  name: k
}, {
  __name: "notification-bar",
  props: {
    /**
     * Notification link, destination url information.
     * @property {String} link.title
     * @property {String} link.url
     * @property {Boolean} link.openInNewWindow
     * @property {Boolean} link.nuxt
     */
    link: {
      type: Object,
      required: !0,
      validator: (t) => t ? ["title", "url", "openInNewWindow", "nuxt"].every((e) => e in t) : !0
    },
    /**
     * Notification has icon, Condition for rendering icon
     */
    icon: {
      type: Object,
      default: () => ({
        category: "",
        name: ""
      }),
      validator: (t) => t ? ["category", "name"].every((e) => e in t) : !0
    },
    /**
     * Notification close conditions
     * contains manual toggle button option,
     * automatic closing option and automatic closing timer
     */
    closeConditions: {
      type: Object,
      required: !0,
      validator: (t) => t ? ["manual", "auto", "autoTime"].every((e) => e in t) : !0
    },
    /**
     * Dark mode prop, enables darkmode
     */
    darkMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const a = t, y = e, r = w(!1), { trackingDataProvided: v } = j(), g = s(() => ({
      [`notification-bar--${a.darkMode ? "dark" : "light"}`]: !0,
      "notification-bar--hidden": !r.value
    })), x = s(() => a.darkMode ? "black" : "white"), b = s(() => {
      var n, i;
      return ((i = (n = a.icon) == null ? void 0 : n.category) == null ? void 0 : i.length) > 0;
    }), u = () => {
      r.value = !1, setTimeout(() => {
        y("close");
      }, 10);
    };
    return C(() => {
      var n, i;
      setTimeout(() => {
        r.value = !0;
      }, 10), (n = a.closeConditions) != null && n.auto && setTimeout(() => {
        u();
      }, (i = a.closeConditions) == null ? void 0 : i.autoTime);
    }), (n, i) => (o(), d(h, { name: "fade" }, {
      default: N(() => [
        t.link ? (o(), m("div", {
          key: 0,
          class: p([g.value, "notification-bar"]),
          "data-j-notification-bar": ""
        }, [
          f("div", $, [
            f("div", E, [
              b.value && t.icon ? (o(), d(l(z), {
                key: 0,
                class: "notification-bar--icon ds-margin-right-8",
                category: t.icon.category,
                name: t.icon.name,
                "data-j-icon": ""
              }, null, 8, ["category", "name"])) : c("", !0),
              t.link ? (o(), d(l(M), {
                key: 1,
                variant: "tertiary",
                "data-j-link": "",
                "tracking-data": {
                  "component-name": k,
                  text: t.link.title,
                  title: t.link.title,
                  ...l(v)
                },
                url: t.link.url,
                "lazy-url-endpoint": t.link.lazyUrlEndpoint,
                content: t.link.title,
                "open-in-new-window": t.link.openInNewWindow,
                color: x.value,
                nuxt: t.link.nuxt
              }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "content", "open-in-new-window", "color", "nuxt"])) : c("", !0)
            ])
          ]),
          t.closeConditions.manual ? (o(), m("div", {
            key: 0,
            class: "notification-bar__close ds-display-flex ds-align-items-center",
            "data-j-close": "",
            onClick: u
          }, [
            T(l(O), {
              category: "interface",
              name: "cross"
            })
          ])) : c("", !0)
        ], 2)) : c("", !0)
      ]),
      _: 1
    }));
  }
}), _ = /* @__PURE__ */ B(I, [["__scopeId", "data-v-12c7d304"]]);
export {
  _ as default
};
